import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { InstalledApplicationsEffects } from './installed-applications.effects';
import { installedApplicationsReducer } from './installed-applications.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('installed-applications', installedApplicationsReducer),
    EffectsModule.forFeature([InstalledApplicationsEffects]),
  ],
  providers: [],
})
export class InstalledApplicationsStoreModule {}
